import { ReactNode } from "react";
import {
  AdoptiveParentInformation,
  State,
  stateDisplayNames,
} from "../../types/coreApiMirror";
import {
  getArchetypeIcon,
  translateArchetypeName,
} from "../../utils/getArchetypeIcon";
import { getClassName } from "@pairtreefamily/utils";
import { HomeStudyVerified } from "../homeStudyVerified";
import GalleryTile from "./galleryTile";

export type ParentDetailsCardProps = AdoptiveParentInformation & {
  homeStudyApproved?: boolean;
  state?: string;
  single?: boolean;
};

export function ParentDetailsCard(props: ParentDetailsCardProps) {
  const {
    first_name,
    archetype,
    gender,
    religion,
    education,
    profession,
    political_affiliation,
    single,
  } = props;

  const className = getClassName(
    "p-10",
    "text-center",
    "flex flex-col gap-2",
    "bg-white text-onyx",
  );

  const archetypeName = translateArchetypeName(archetype?.name);

  return (
    <GalleryTile size={single ? "lg" : "tall"} className={className}>
      <h2 className="text-head-5">{first_name}</h2>
      <div className="mb-2 flex flex-col items-center">
        <p className="text-body-1 text-green">
          <strong>{archetype?.name}</strong>
        </p>
        {archetypeName && (
          <img
            src={getArchetypeIcon(archetypeName)}
            className={"filter-green my-1"}
            alt=""
            width={35}
          />
        )}
      </div>
      <div className="flex flex-row">
        <Attribute
          className={getClassName(
            "border-y-2 border-backgroundgray",
            props.homeStudyApproved ? "grow border-r-2" : "w-full",
          )}
          label="Gender"
          val={gender}
        />
        {props.homeStudyApproved && (
          <Attribute
            className="grow border-y-2 border-backgroundgray"
            label="Status"
            val={
              <HomeStudyVerified
                className={"mx-auto"}
                altText={"Home study has been approved"}
              />
            }
          />
        )}
      </div>
      {props.state && (
        <Attribute
          label="State"
          val={
            props.state in stateDisplayNames
              ? stateDisplayNames[props.state as State]
              : props.state
          }
        />
      )}
      <Attribute label="Religion" val={religion} />
      <Attribute label="Education" val={education} />
      <Attribute label="Profession" val={profession} />
      <Attribute label="Political Affiliation" val={political_affiliation} />
    </GalleryTile>
  );
}

const Attribute = (props: {
  label: string;
  val: string | ReactNode;
  className?: string;
}) => (
  <div className={getClassName("p-2", props.className)}>
    <p className="text-body-4">{props.label}: </p>
    <p className="text-body-3-medium">
      <strong>{props.val}</strong>
    </p>
  </div>
);

export default ParentDetailsCard;
